import React from 'react';
import './Style.css';
import logo from "../../img/Wa.I.San Jpeg final.jpg";

import { useNavigate } from "react-router-dom";

export default function LandingPage3() {
    const navigate = useNavigate(); // Initialize useNavigate hook

    // Function to handle navigation
    const navigateHome = () => {
        navigate("/home");
    };

    return (
        <div>
            <div className="landing-container-custom">
                <div className="overlay-custom">
                    <div className="landing-logo-custom">
                        <img src={logo} alt="Wā.I.Saṅ Logo" className="logo-custom" />
                    </div>
                    {/* <div className="text-container-custom">
                        <div className="text-title-custom">Wā.I.Saṅ</div>
                        <div className="text-subtitle-custom">Wārsā Itihās and Saṅskritī!</div>
                        <div className="text-description-custom">Celebrating heritage</div>
                    </div> */}
                    <button className="explore-button-custom" onClick={navigateHome}>
                        Explore
                    </button>
                </div>
            </div>
        </div>
    );
}
